import { Navigate } from "react-router-dom";
import { getBusiness } from "./store/menupro.store";

// Login olmuş istifadəçi görməli olan səhifələr
export const ProtectedRoute = ({ children }) => {
  const biz = getBusiness();
  return biz ? children : <Navigate to="/menupro/login" />;
};

// Login olmamış istifadəçi görməli olan səhifələr
export const PublicOnlyRoute = ({ children }) => {
  const biz = getBusiness();
  return biz ? <Navigate to="/menupro/dashboard" /> : children;
};
